import './loading.css';
import Logo from '../../assets/logos/logo-transparent.png'
import { useLocation } from 'react-router-dom';

const LoadingComponent = () => {
  const location = useLocation();

  const containerStyle = { display: location.pathname === '/' ? 'none' : 'flex' };

  return (
    <div className="loading-page">
      <div className="loading-container" style={containerStyle}>
        <img src={Logo} alt='brand logo' />
        <p>Just give us a moment...</p>
      </div>
    </div>
  )
}

export default LoadingComponent